import { useState } from "react";
import { FeedbackModal } from "@/components/feedback";
import { useOptimisticCart } from "@/hooks/use-optimistic-cart";
import { DeleteIcon } from "@/icons";
import { emitCartBump } from "@/lib/fly-to-cart";
import { CartItem } from "@/types";
import { IconButton, QUANTITY_STEPPER_GLYPH, Text } from "@/components/ui";

export default function DeleteItemModal({ cartItem }: { cartItem: CartItem }) {
  const [open, setOpen] = useState(false);
  const { removeItem } = useOptimisticCart();

  function handleDelete() {
    removeItem(cartItem.id);
    emitCartBump("remove");
    setOpen(false);
  }

  return (
    <>
      <IconButton
        icon={DeleteIcon}
        label="Remover item"
        variant="ghost"
        tone="danger"
        size="icon-sm"
        iconSize={QUANTITY_STEPPER_GLYPH.md}
        data-testid="cart-item-remove"
        onClick={() => setOpen(true)}
      />
      <FeedbackModal
        open={open}
        onOpenChange={setOpen}
        variant="warning"
        confirmTone="danger"
        title="Remover item"
        description={(
          <p>Quer mesmo tirar <Text as="strong" weight="bold" tone="default">{cartItem.item.name}</Text> da sacola?</p>
        )}
        confirmLabel="Sim, remover"
        cancelLabel="Voltar"
        onConfirm={handleDelete}
      />
    </>
  );
}
